import React from 'react';
import { keys } from 'lodash';
import { textStyles } from 'components/ds/tokens/text-styles';
import { Text } from 'naan/primitives/text';
import { VStack } from 'naan/primitives/stack';

const sampleText = 'Lorem ipsum dolor sit amet consectetur ';

export const pathname = '/text-styles';
export const navlabel = 'Text Styles';
export const naanReady = true;

export const Screen = () => {
  const styles = keys(textStyles);
  return (
    <>
      <VStack gap="medium">
        {styles.map(style => {
          return (
            <VStack gap="small">
              <Text as={'p'} textStyle={style}>
                {sampleText}
              </Text>
              {/* <div style={{ height: '6px' }}></div> */}
              <Text textStyle="small-text-bold" color="textSecondary">
                {style}
              </Text>
              <div style={{ height: '24px' }}></div>
            </VStack>
          );
        })}
      </VStack>
    </>
  );
};
